import { Copyright } from '../Copyright'

export function Footer() {
  return <footer>
    <Copyright />
  </footer>
}